/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { NumberFormatter } from './NumberFormatter.js';
/**
 * Creates a {@link NumberFormatter} with the given number of decimal places..
 */

export function createTicksFormat(shorthandLabels, decimalPlaces) {
  return new NumberFormatter(shorthandLabels, decimalPlaces);
}
/**
 * Creates a {@link NumberFormatter} with the given number of minimum and maximum fraction digits.
 */

export function createTicksFormatMinMax(shorthandLabels, minFractionDigits, maxFractionDigits) {
  return new NumberFormatter(shorthandLabels, minFractionDigits, maxFractionDigits);
}
